import { ArrowRight } from 'lucide-react';
import { useInView } from '../../hooks/useInView';

export default function FinalCTA({ tool }) {
  const [ref, inView] = useInView(0.15);

  return (
    <section className="py-20 sm:py-28 bg-white overflow-hidden">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div
          ref={ref}
          className="relative rounded-3xl overflow-hidden text-center px-8 py-16 sm:py-20"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? 'scale(1)' : 'scale(0.96)',
            transition: 'opacity 0.65s ease, transform 0.65s ease',
          }}
        >
          {/* Background */}
          <div className="absolute inset-0 bg-hero-gradient" />

          {/* Blobs */}
          <div className="absolute -top-20 -left-20 w-64 h-64 rounded-full bg-brand-blue opacity-25 blur-3xl animate-float" />
          <div className="absolute -bottom-20 -right-20 w-64 h-64 rounded-full bg-brand-indigo opacity-30 blur-3xl animate-float-slow" />

          {/* Grid overlay */}
          <div
            className="absolute inset-0 opacity-5"
            style={{
              backgroundImage:
                'linear-gradient(rgba(255,255,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
              backgroundSize: '40px 40px',
            }}
          />

          {/* Content */}
          <div className="relative z-10">
            <span className="inline-block px-4 py-1.5 rounded-full glass text-white/70 text-xs font-bold tracking-widest uppercase mb-6">
              Free — No Account Required
            </span>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white leading-tight tracking-tight mb-5">
              Ready to Get Started?
            </h2>

            <p className="text-lg text-white/60 max-w-md mx-auto leading-relaxed mb-10">
              Launch FileMingle's {tool.h1.toLowerCase()} tool instantly — no download, no sign-up.
            </p>

            <a
              href={tool.appUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2.5 px-9 py-4 rounded-full bg-white text-brand-blue font-bold text-base shadow-2xl shadow-black/30 hover:shadow-white/20 hover:scale-105 transition-all duration-250"
            >
              {tool.primaryCta}
              <ArrowRight
                size={18}
                aria-hidden="true"
                className="transition-transform duration-200 group-hover:translate-x-1"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
